import React from 'react';
import UseCaseModals from './admin/modals/UseCaseModals';
import ConfirmationModals from './admin/modals/ConfirmationModals';
import BetaModals from './admin/modals/BetaModals';
import QuickscanDetailWrapper from './admin/modals/QuickscanDetailWrapper';
import ContentModals from './admin/modals/ContentModals';
import BookingModal from './admin/modals/BookingModal';
import UserModals from './admin/modals/UserModals';

/**
 * AdminModals - Composition root for all admin dialogs.
 * Each domain-specific modal group is split into its own file for maintainability.
 * Groups consume state/actions via useAdminContext() so there's no prop-drilling.
 */
const AdminModals = () => (
  <>
    <UseCaseModals />
    <ConfirmationModals />
    <BetaModals />
    <QuickscanDetailWrapper />
    <ContentModals />
    <BookingModal />
    <UserModals />
  </>
);

export default AdminModals;
